<template>
    <b-container class="bv-example-row">
        <b-row :align-h="getAlign" v-if="mensagem">
            <b-alert :variant="getVariant" show class="alert-msg">
                <b-row class="mb-2">
                    <b-col>
                        <small>
                            <b-avatar variant="light" :src="getPath" size="sm"></b-avatar>
                            <b-badge v-if="mensagem.user_id !== parseInt(getUserId)" variant="light">{{
                                mensagem.user.name }}</b-badge>
                            <b-badge v-else variant="light">Você</b-badge>
                        </small>
                    </b-col>
                    <b-col class="text-right">
                        <b-badge variant="light"><b-icon icon="clock"></b-icon>
                            <small> {{ dateFormatted }}</small>
                        </b-badge>
                    </b-col>
                </b-row>
                <b-row v-if="mensagem.mensagem" class="mt-2">
                    <p>{{ mensagem.mensagem }}</p>
                </b-row>
                <b-row v-if="mensagem.arquivos && mensagem.arquivos.length > 0" class="mt-2">
                    <b-col v-for="(arquivo, index) in mensagem.arquivos" :key="index">
                        <a href="#" @click="visualizar(arquivo)"> <b-img v-if="getTipo(arquivo.tipo) == 'image'"
                                :src="arquivo.url" fluid thumbnail v-bind="mainProps" rounded alt="Rounded image" />
                            <i class="fas fa-file-pdf fa-lg" v-else></i>
                        </a>
                    </b-col>
                </b-row>
            </b-alert>
        </b-row>
        <b-modal v-model="modalImagem" hide-footer size="xl">
            <b-img v-if="anexoSelecionado" fluid :src="anexoSelecionado.url"></b-img>
        </b-modal>
    </b-container>
</template>

<script>
export default {
    props: {
        mensagem: {
            type: Object,
            default: {}
        },
    },
    data() {
        return {
            mainProps: { width: 75, height: 75 },
            anexoSelecionado: null,
            modalImagem: false
        }
    },
    watch: {
        modalImagem(newValue) {
            if (!newValue) {
                this.anexoSelecionado = null;
            }
        }
    },
    computed: {
        getPath() {
            if (this.mensagem && this.mensagem.user && this.mensagem.user.path) {
                return this.mensagem.user.path.replace('public', '/storage');
            }
            return '';
        },
        isDistribuidor() {
            return this.$store.getters['user/isDistribuidor'];
        },
        getUserId() {
            return parseInt(this.$store.getters['user/getUserId']);
        },
        user() {
            return parseInt(this.$store.getters['user/getUser']);
        },
        dateFormatted() {
            return new Date(this.mensagem.created_at).toLocaleString();
        },
        getAlign() {
            if (this.mensagem.user_id == this.getUserId) return 'end';
            return 'start';
        },
        getVariant() {
            if (this.mensagem.user_id == this.getUserId) return 'success';
            return 'primary';
        }
    },
    methods: {
        visualizar(arquivo) {
            if (this.getTipo(arquivo.tipo) == 'image') {
                this.anexoSelecionado = arquivo;
                this.modalImagem = true
            } else {
                window.open(arquivo.url, '_blank')
            }
        },
        getTipo(tipo) {
            if (tipo == 'jpg' || tipo == 'jpeg' || tipo == 'png' || tipo == 'gif') return 'image'
            return 'file'
        }
    }
}

</script>

<style>
.alert-msg {
    width: 500px;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/atendimento/Mensagens.vue